// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"113":"3bba057b","438":"0dcde965","538":"88db8399","932":"9d6ee489"}[chunkId] + ".chunk.js";
};